<template>
  <div class="footer">
    <div class="footer-content">
      <div class="logo">
        <img :src="logoImg" alt="" />
      </div>
      <div class="contact">
        <p>
          <!-- COPYRIGHT © 2024 ALL RIGHTS RESERVED. bazhan.com 版权所有
          湘ICP备29-21018127号-13 -->
          <span>服务热线</span>
          <em>0721-1234567</em>
        </p>
        <p>
          <span>客服QQ</span>
          <em>279761312</em>
        </p>
      </div>
      <div class="copyright">
        <p>
          <span
            class="copyright-btn"
            @click="openAgreement(AGREEMENT_TYPE.SERVICE_PROTOCOL)"
            >服务协议</span
          >
          <span
            class="copyright-btn"
            @click="openAgreement(AGREEMENT_TYPE.PRIVACY_PROTOCOL)"
            >隐私协议</span
          >
        </p>
        <p>
          鄂ICP备2022005501号-1 增值电信业务许可证:鄂B2-20220460
          鄂网文(2022)2416-231号
        </p>
        <p>特别申明:霸战网络为工具提供方不参与游戏内容改动和网站的运营工作</p>
      </div>
    </div>
    <Agreement ref="agreementRef" />
  </div>
</template>

<script lang="ts">
import { Vue, Component, Ref } from "vue-property-decorator";
import logoImg from "@/assets/images/footer/logo.png";
import contactImg from "@/assets/images/footer/contact.png";
import { AGREEMENT_TYPE } from "@/utils/enums";
import Agreement from "@/components/account/agreement.vue";
@Component({
  components: {
    Agreement: () => import("@/components/account/agreement.vue"),
  },
})
export default class Footer extends Vue {
  AGREEMENT_TYPE = AGREEMENT_TYPE;
  logoImg = logoImg;
  contactImg = contactImg;
  @Ref() readonly agreementRef!: Agreement;
  openAgreement(t: AGREEMENT_TYPE) {
    const agreementRef = this.$refs.agreementRef as Agreement;
    agreementRef.open(t);
  }
}
</script>

<style lang="scss" scoped>
.footer {
  height: 164px;
  background-image: url(@/assets/images/footer/footer_bg.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;

  &-content {
    display: flex;
    align-items: center;
    width: 1200px;
    height: 100%;
    margin: 0 auto;

    .logo {
      width: 155px;
      height: 40px;

      > img {
        width: 100%;
        height: 100%;
      }
    }

    .contact {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 100%;
      margin: 0 109px 0 93px;
      padding: 20px 0;

      > p {
        display: flex;
        flex-direction: column;
        color: #f5d587;

        > span {
          font-size: 16px;
          font-weight: 400;
          line-height: 20px;
        }

        > em {
          margin-top: 6px;
          font-size: 20px;
          font-style: normal;
          font-weight: 700;
          line-height: 27px;
        }
      }
    }

    .copyright {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      flex: 1;
      width: 144px;
      height: 170px;
      padding: 20px 0;
      color: #f5d587;
      font-size: 14px;

      &-btn {
        cursor: pointer;
        text-decoration: underline;

        &:last-child {
          margin-left: 20px;
        }
      }
    }
  }
}
</style>
